import { render, staticRenderFns } from "./AClave.vue?vue&type=template&id=35215a7e&scoped=true"
import script from "./AClave.vue?vue&type=script&lang=js"
export * from "./AClave.vue?vue&type=script&lang=js"
import style0 from "./AClave.vue?vue&type=style&index=0&id=35215a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35215a7e",
  null
  
)

export default component.exports